import moment from 'moment';
import { CalcCalorieMax, interpolateWeightLogHistory } from '../bmr/bmr';

// Synthetic example. Its True Weight and calorie target use the product's
// actual functions, rather than unrelated hard-coded marketing numbers.
const values = [184.2,183.9,184.5,183.2,183.8,183.0,182.5,182.7,182.9,182.4,181.8,182.2,181.3,181.4];
const history = interpolateWeightLogHistory(values.map((value, i) => ({ date: `2026-08-${i + 18}`, value })));
const last = history[history.length - 1];
export const demo = {
  weight: last.value,
  trueWeight: last.trueWeight!,
  calorieMax: CalcCalorieMax(last.trueWeight!, 175, {
    gender: 'male', height_in: 70,
    birthday: moment().subtract(35, 'years').format('YYYY-MM-DD'),
    goal_end_date: moment().add(90, 'days').format('YYYY-MM-DD'),
  }),
};
